import React, {
  useEffect, useRef, useCallback, forwardRef, useImperativeHandle,
} from 'react';

import { EditTwoTone, DeleteTwoTone } from '@ant-design/icons';
import { Space, Tooltip } from 'antd';

import useManager from '../../../hooks/manager';
import Table from '../../Table';
import ColumnSearch from '../../Table/Filter';
import { Action } from '../../Table/styles';
import UpdateForm from '../UpdateForm';

const MatrizFilialTable = forwardRef((_props, ref) => {
  const updateRef = useRef();
  const {
    loading, datas, destroy, load,
  } = useManager();

  const loadData = useCallback(() => {
    load('/matriz-filial');
  }, [load]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  useImperativeHandle(ref, () => ({
    reload: loadData,
  }));

  const columns = [
    {
      title: 'Matriz',
      dataIndex: ['matriz', 'fantasyName'],
      key: 'matriz',
      ellipsis: true,
      render: (_text, record) => {
        const m = record.matriz || {};
        return `${m.fantasyName || ''} - ${m.name || ''}${m.cnpj ? ` (${m.cnpj})` : ''}`;
      },
      ...ColumnSearch('Matriz', 'matriz'),
    },
    {
      title: 'CNPJ Matriz',
      dataIndex: ['matriz', 'cnpj'],
      key: 'matrizCnpj',
      ellipsis: true,
    },
    {
      title: 'Filiais',
      dataIndex: 'filiais',
      key: 'filiais',
      ellipsis: true,
      render: (filiais) => (filiais || [])
        .map((f) => `${f.fantasyName || f.name}${f.cnpj ? ` (${f.cnpj})` : ''}`)
        .join(', '),
    },
    {
      title: 'Qtd. Filiais',
      key: 'filiaisCount',
      width: 110,
      align: 'center',
      render: (_text, record) => (record.filiais || []).length,
    },
  ];

  return (
    <>
      <UpdateForm ref={updateRef} onSuccess={loadData} />
      <Table
        data={datas}
        loading={loading}
        columns={columns}
        actions={{
          title: 'Ações',
          key: 'action',
          width: 100,
          align: 'center',
          render: (text, record) => (
            <Space size="middle">
              <Tooltip placement="top" title="Alterar">
                <Action onClick={() => updateRef.current.open(record.id || record._id)}>
                  <EditTwoTone />
                </Action>
              </Tooltip>
              <Tooltip placement="top" title="Excluir">
                <Action onClick={() => destroy(record.id || record._id, '/matriz-filial', loadData)}>
                  <DeleteTwoTone twoToneColor="#f00" />
                </Action>
              </Tooltip>
            </Space>
          ),
        }}
      />
    </>
  );
});

export default MatrizFilialTable;
